import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Spinner } from '@mssgme/ui';
import { withApi } from '../withApi';
import { ERROR_MESSAGES_MAP, useViberIntegration } from './useViberIntegration';

import styles from '../commonStyles.scss';

function ViberIntegration({ isFetching, errors, request }) {
    const { t, handleSubmit, token, setToken } = useViberIntegration({ request });

    return (
        <form onSubmit={handleSubmit} className={styles.rootContainer}>
            <ol className={styles.list}>
                <li
                    dangerouslySetInnerHTML={{
                        __html: t('viberIntegration.how_to_2.step1'),
                    }}
                />
                <li
                    dangerouslySetInnerHTML={{
                        __html: t('viberIntegration.how_to_2.step2'),
                    }}
                />
                <li
                    dangerouslySetInnerHTML={{
                        __html: t('viberIntegration.how_to_2.step3'),
                    }}
                />
            </ol>
            <input
                type="text"
                placeholder={t('viberIntegration.input.placeholder')}
                value={token}
                onChange={(e) => setToken(e.target.value)}
                disabled={isFetching}
                className={styles.input}
            />
            {errors.token && <span className={styles.error}>{t(errors.token)}</span>}
            <div className={styles.buttonContainer}>
                <button
                    type="submit"
                    className={cn(styles.submitButton, { [styles.active]: !!token, [styles.isFetching]: isFetching })}
                >
                    {isFetching ? (
                        <Spinner size="16" color="white" className={styles.spinner} />
                    ) : (
                        t('viberIntegration.connect')
                    )}
                </button>
            </div>
        </form>
    );
}

ViberIntegration.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    request: PropTypes.func.isRequired,
};

export default withApi(ViberIntegration, 'errorsList.create_integration', (message) => ERROR_MESSAGES_MAP[message]);
